import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
declare var $:any;

@Component({
  selector: 'app-corporate',
  templateUrl: './corporate.component.html',
  styleUrls: ['./corporate.component.scss']
})
export class CorporateComponent implements OnInit {

  constructor(title: Title) {
    title.setTitle("Kurumsal | Eti Gümüş A.Ş.");
   }

  ngOnInit() {
    $(function(){
      // Evu Tabs 
      // All Tabs Hide
      $("div#evuTabsContainer > div.evuTabs").hide();

      // Active Class Tabs Show
      $("div#evuTabsContainer > div.active").show();
      var activeContainerHeight = $("div#evuTabsContainer > div.active").height();
      $("div#evuTabsContainer").css("height", activeContainerHeight + "px");

      $("div.list-group > a.list-group-item").click(function(){
        
        // Class
        $("div.list-group > a.list-group-item").removeClass("active");
        $(this).addClass("active");


        var clicked = $("div.list-group > a.list-group-item").index(this);
        var clickedContainerHeight = $("div#evuTabsContainer > div.evuTabs").eq(clicked).height();
        $("div#evuTabsContainer").animate({
          height: clickedContainerHeight
        }, 300, function() {
          console.log("anim ok");
        });

        $("div#evuTabsContainer > div.evuTabs").fadeOut();

        $("div#evuTabsContainer > div.evuTabs").eq(clicked).fadeIn();

      });
    });
  }
}


// WEBPACK FOOTER //
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/corporate/corporate.component.ts